import * as TestingLibrary from "@testing-library/react";
import render from "./customRender";
import getTestStore, { CustomStoreProps } from "./getTestStore";
import * as props from "./props";
import * as entityMock from "./entityMock";

const { render: _render, ...rest } = TestingLibrary;

export const { act, cleanup, fireEvent, waitFor, screen } = rest;

export { render, getTestStore, props, entityMock };
export type { CustomStoreProps };
